const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      color: theme.colors[0],
      background: theme.colors[1],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    intro: {
      paddingTop: 100,
      paddingBottom: 100,
    },
    additionalText: {
      textTransform: 'uppercase',
      '& .TextBlock__title': {
        fontSize: 16,
      },
      '& .TextBlock__text': {
        fontSize: 16,
      },
    },
    video: {
      marginTop: 100,
      marginBottom: 100,
      '& video': {
        width: '100%',
      },
    },
    abescaLogo: {
      width: 250,
      display: 'block',
      margin: '0 auto',
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
    intro: {
      paddingTop: 50,
      paddingBottom: 50,
    },
    video: {
      marginTop: 50,
      marginBottom: 50,
    },
  }

  return output
}

export default style
